/* import __COLOCATED_TEMPLATE__ from './open-document-button.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './open-document-button.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsOpenDocumentButton extends Component {}
